import { supabase } from '../utils/supabaseClient';
import { getAllDocuments, getAllDocumentFileTypes, generatePresignedUpload, generateDownloadUrlFromPath } from './MetadataService';

/**
 * @deprecated use #getEntityDocuments instead
 */
export const getLocationFilesFromAirtable = async (locationType, id) => {
    var Airtable = require('airtable');
    var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app7kfG35eQYRupcU');

    return new Promise((resolve, reject) => {
        let files = []
        base('location_file_fact').select({
            maxRecords: 5000,
            view: 'With Lookups',
        }).firstPage((err, records) => {		
            records.forEach(function(record) {
                if ((record.fields.site_id && locationType === "Site" && record.fields.site_id[0] == id) ||
                    (record.fields.building_id && locationType === "Building" && record.fields.building_id[0] == id)
                ) {
                    let accessInfo = record["fields"]["file_contents"];
                    accessInfo && accessInfo.forEach(f => {
                        files.push({
                            "name": record["fields"]["file_name"][0],
                            "type": record["fields"]["file_type"][0],
                            "size": f.size,
                            "thumbnail_sm": f.thumbnails && f.thumbnails.small.url,
                            "thumbnail_lg": f.thumbnails && f.thumbnails.large.url,
                            "url": f.url
                        })
                    })
                }
            });

			console.log(files)
            resolve(files);
        });  
    })
}

const entityFilesTable = 'entity_files';
const entityFilesBucket = 'entity-files';
const dimFileTypesTable = 'dim_file_type';

/**
 * @deprecated use #getEntityDocuments instead
 */
export const getFilesFromSupabase = async (context, id) => {
	const entityKey =  `${context}_${id}`

    let { data, error, status } = await supabase
        .from(entityFilesTable)
        .select(
          `
          file_url,
          created_at,
          caption,
          filename,
          uploaded_by,
          dim_file_type (
            name
          )
        `,
        )
        .eq('entity_key', entityKey)
        .order('created_at', { ascending: false });
  
		if (error && status !== 406) {
			throw error;
		}

		return data;
  }

export const getEntityDocuments = async (entityType, entityId) => {
	const [docs, types] = await Promise.all([
		getAllDocuments(entityType, entityId),
		getEntityDocumentFileTypes(entityType)
	])
	return docs.map(d => {
		const path = d.file_type != null ? `${types.indexOf(d.file_type)+1}/${d.file_name}` : d.file_name;
		const root = d.entity.type === "equipment" ? "equipment" : `locations/${d.entity.type}`
		return {
			name: d.file_name,
			type: d.file_type,
			url: `${root}/${d.entity.id}/documents/${path}`,
			source: "s3",
			uploaded_by: null,
			upload_date: new Date(d.meta.last_modified),
		}
	}) 
}

export const getEntityDocumentFileTypes = async (entityType) => {
	return getAllDocumentFileTypes(entityType);
}	

export const addDocument = async (entityType, entityId, upload) => {
	const path = upload.fileTypeId != null ? `${upload.fileTypeId}/${upload.fileName}` : upload.fileName;
	const presigned = await generatePresignedUpload(entityType, entityId, path);
	
	const formData = new FormData();
	Object.entries(presigned.fields).forEach(([key, value]) => formData.append(key, value));
	formData.append("file", upload.file);

	const response = await fetch(presigned.url, {
		method: "POST",
		body: formData
	})

	if (!response.ok) {
		throw new Error(response.statusText);
	}

	return response;
}

/**
 * @deprecated use #getEntityDocumentFileTypes instead
 */
export const getFiletypesOptions = async () => {
		const opts = await getEntityDocumentFileTypes('locations/sites')
		return opts.map((label, value) => {
			return { label, value: value+1 };
		});
		
}

/**
 * @deprecated use #addDocument instead
 */
export const addFile = async (fileToUpload) => {
	const [entityName, entityId] = fileToUpload.entityKey.split('_');
	const entityType = entityName === 'equipment' ? 'equipment' : `locations/${entityName}s`
	return addDocument(entityType, entityId, fileToUpload);
}

/**
 * @deprecated use #getFullFileURL instead
 */
export const downloadFile = async (fileUrl) => {
	return generateDownloadUrlFromPath(fileUrl);
}

export const getFullFileURL = async (fileUrl) => {
	return generateDownloadUrlFromPath(fileUrl);
}